<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title" *ngIf="!organizationTypeId"> {{'organizationType.createOrganizationTypesSearch' | translate}}</span>
    <span class="panel-title" *ngIf="organizationTypeId"> {{'organizationType.editOrganizationTypesSearch' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2" novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (name.dirty || name.touched || f.submitted)  && name.valid, 'has-error' : (name.dirty || name.touched || f.submitted)  && name.invalid}">
              <label class="control-label">{{'app.name' | translate}} </label>
              <input type="text"
                     name="name"
                     [(ngModel)]="organizationType.name"
                     #name="ngModel"
                     required="required"
                     class="form-control" />
              <div *ngIf="(name.dirty || name.touched || f.submitted)  && name.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (parentId.dirty || parentId.touched || f.submitted)  && parentId.valid, 'has-error' : (parentId.dirty || parentId.touched || f.submitted)  && parentId.invalid}">
              <label class="control-label">{{'organizationType.parentorganizationType' | translate}} </label><br />


              <span class="ui-fluid">

                <p-dropdown [options]="organizationTypes"
                            name="parentId" #parentId="ngModel"
                            styleClass="wid100"
                            placeholder="Parent Org Type"
                            emptyFilterMessage="No results found"
                            showClear="true"
                            [styleClass]="form-control"
                            [(ngModel)]="organizationType.parentOrganozationType"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>

              </span>

            </div>
          </div>

          <div class="col-sm-6" *ngIf="applyAmPmOrganizationType == 'True' ">
            <label class="control-label"> </label>
            <div>
              <ui-switch uncheckedLabel="PM"
                         checkedLabel="AM"
                         name="isAM"
                         #isAM="ngModel"
                         [(ngModel)]="organizationType.isAm"
                         size="large"></ui-switch>

            </div>
          </div>
          <div class="col-sm-6" *ngIf="isVisitsGridClassBased">
            <div>
              <label class="control-label">{{'organizationType.visitClass' | translate}} </label>
              <div class="form-group">
                <select name="visitClassSlot" #visitClassSlot="ngModel" [(ngModel)]="organizationType.visitClassSlot" class="form-control">
                  <option *ngFor="let opt of visitClassSlotOptions" [ngValue]="opt.value">{{opt.label}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div>
              <label class="control-label"> </label>
              <div class="form-group">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" #active="ngModel" name="specifictarget" [(ngModel)]="organizationType.hasSpecificTarget">
                    {{'organizationType.specificTarget' | translate}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div>
              <label class="control-label"> </label>
              <div class="form-group">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" name="isHide" [(ngModel)]="organizationType.isHide">
                    {{'organizationType.isHide' | translate}}
                  </label>
                  <p class="help-block" style="margin: 2px 0 0;">{{'organizationType.isHideHint' | translate}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit">{{'app.save' | translate}}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




